import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { SORT_OPTIONS } from './constants';
import { SortIcon } from '../icons';
import withTranslate from '../../hoc/with-translate';
import styles from './member-sort-field-mobile.scss';

const MembersSortFieldMobile = ({ className, value, onChange, t }) =>
  <div className={classNames(styles.container, className)}>
    <SortIcon className="forum-icon-fill"/>
    <select className={styles.select} value={value} onChange={e => onChange(e.target.value)}>
      {_.map(SORT_OPTIONS, (translation, value) =>
        <option value={value}>
          {t(translation)}
        </option>
      )}
    </select>
  </div>;

MembersSortFieldMobile.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func,
};

export default withTranslate(MembersSortFieldMobile);



// WEBPACK FOOTER //
// ./app/components/member-sort-field/member-sort-field-mobile.js